// extracted by mini-css-extract-plugin
module.exports = {"container":"price_container__GTzIQ","price":"price_price__PIBCf","discounted":"price_discounted__Wlbjd"};